import { Loader } from '@ui-kit/components/loader';
import { t } from '@base/utils/helpers';
import { objectKeys } from '@utils/functions';
import React from 'react';
import { container } from 'tsyringe';
import { IUserService } from '@base/features/user/model/interfaces';
import InfoItem from '@base/features/user/components/infoItem';
import Rating from '@base/features/user/components/rating';
import styles from '@base/features/user/styles/statistics.module.scss';
import { useAsyncData } from '@utils/hooks';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';

export default function Statistics() {
  const userService: IUserService = container.resolve('userService');
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const me = playersOnlineRepository.me;
  const { data: statistics, loading, error } = useAsyncData(() =>
    userService.getUserInfo().then((personalInfo) => userService.getPlayerStats(personalInfo.user_id))
  );

  if (loading)
    return (
      <div>
        <Loader />
      </div>
    );
  if (error) return <span>{error.message}</span>;
  if (!statistics) return <span>No statistics</span>;

  const formatWonLost = (won?: number, lost?: number) => (won ? won : 0 + '/' + lost ? lost : 0);

  const gameStats = {
    games: statistics.NGames,
    week_won_lost: formatWonLost(statistics.WeekWon, statistics.WeekLost),
    games_won: statistics.NWon,
    month_won_lost: formatWonLost(statistics.MonthWon, statistics.MonthLost),
    win_percent: statistics.WinPC ? statistics.WinPC + '%' : '',
    streak: statistics.Streak,
    idle_days: statistics.Idle,
  };

  const ladderStats = {
    ladder_ranking: statistics.Rank,
    tourney_games_won: statistics.NTrnGamesWon,
    best_rank: statistics.BestRank,
    n_tourney_games: statistics.NTrnGames,
    ladder_points: statistics.LPoints,
    tourneys_won: statistics.NTourneysWon,
    tourneys: statistics.NTourneys,
  };

  return (
    <div className={styles.statistics}>
      <StatisticsSection title="game_statistics" stats={gameStats} >
        {me && (
          <div className={styles.rating}>
            <span>{t('rating')}</span>
            <Rating>{me.getRating()}</Rating>
          </div>
        )}
      </StatisticsSection>
      <StatisticsSection title="ladder_statistics" stats={ladderStats} />
    </div>
  );
}

function StatisticsSection(props: { title: string; stats: Record<string, any>; children?: JSX.Element }) {
  return (
    <section>
      <h1>{t(props.title)}</h1>
      {props.children}
      <div className={styles.grid}>
        {objectKeys(props.stats).map((key) => (
          <InfoItem key={key} title={key}>
            {props.stats[key] || 0}
          </InfoItem>
        ))}
      </div>
    </section>
  );
}
